import React from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';

import './style.scss';

interface BackButtonProps {
  text: string;
  to: string;
}

const BackButton = ({ text, to }: BackButtonProps) => (
  <div className="BackButton">
    <span className="icon icon-arrow-left icon-variant-3" />
    <CoreLink className="BackButton__link magic-line magic-line--water-blue" to={to}>
      {text}
    </CoreLink>
  </div>
);

export default BackButton;
